<template>
    <div data-app class="p-1">
        <v-card class="mx-auto hidden-card">
            <maximize-and-minimize></maximize-and-minimize>
            <v-card-title>
                <h4 class="title pt-1">Pesquisar</h4>
            </v-card-title>
            <div class="card-content">
                <div>
                    <v-row>
                        <v-col v-if="!isPublic" cols="12" md="4">
                            <v-autocomplete
                                v-model="branch"
                                :items="branches"
                                item-text="name"
                                :search-input.sync="searchBranches"
                                cache-items
                                class="mx-4"
                                flat
                                hide-no-data
                                hide-details
                                label="Filial"
                                return-object
                                :disabled="disableBranchSearch"
                                clearable
                            />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="product"
                                :items="products"
                                item-text="name"
                                :search-input.sync="searchProducts"
                                cache-items
                                class="mx-4"
                                flat
                                hide-no-data
                                hide-details
                                label="Produto"
                                return-object
                                clearable
                            />
                        </v-col>
                    </v-row>

                    <div class="add-btn">
                        <Button
                            label="Adicionar"
                            @click.native="addProduct"
                            color="#3F51B5"
                        />
                    </div>
                </div>
            </div>
        </v-card>

        <h4 class="pb-2">Lista de Produtos à serem solicitados</h4>
        <v-card v-show="loading" class="text-center">
            <img src="loader.svg" style="width: 100px; height: 100px" />
        </v-card>
        <div v-show="!loading">
            <div class="card-row">
                <div
                    class="card-column"
                    v-for="(i, index) in items"
                    :key="index"
                >
                    <flip-card
                        :title="i.title"
                        :referenceNumber="i.referenceNumber"
                        :data="i.data"
                        :img="i.img"
                        :hide-checkbox="true"
                        :cardStyle="{ background: i.backgroundColor }"
                        :editableItems="['solicitation']"
                        :hiddenItems="['parameters']"
                    >
                        <template slot="img-footer">
                            <v-container class="p-0 m-0">
                                <v-row>
                                    <v-col>
                                        <img
                                            :src="
                                                `/img/chip_${i.curve.toLowerCase()}.svg`
                                            "
                                            :alt="`Classe: ${i.curve}`"
                                            :title="`Classe: ${i.curve}`"
                                        />
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-icon
                                            v-if="i.isGuaranteedStock"
                                            title="Garantido"
                                            style="color:var(--red-400)"
                                        >
                                            mdi-lock
                                        </v-icon>
                                        <v-icon
                                            v-if="i.isFavorite"
                                            title="Favorito"
                                            style="color:var(--yellow-400)"
                                        >
                                            mdi-star
                                        </v-icon>
                                        <span v-if="i.isNew" title="Novo">
                                            <img
                                                src="/img/new-product.png"
                                                alt="Novo Produto"
                                                title="Novo Produto"
                                            />
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                        <template slot="actions">
                            <v-btn
                                icon
                                color="#f55a4e"
                                @click="removeProduct(index)"
                            >
                                <v-icon large>
                                    mdi-trash-can
                                </v-icon>
                            </v-btn>
                        </template>
                        <template slot="item" slot-scope="{ prop }">
                            <div
                                v-if="
                                    prop.title ===
                                        extraProductTitles.DC_OVERVIEW.name
                                "
                            >
                                <table class="card-table">
                                    <thead class="center">
                                        <tr>
                                            <th></th>
                                            <th>Estoque</th>
                                            <th>Saldo à Receber</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(propName,
                                            propNameIndex) in Array.from(
                                                new Set(
                                                    prop.props.map(value => {
                                                        return value.name
                                                    })
                                                )
                                            )"
                                            :key="propNameIndex"
                                            :style="
                                                prop.props[propNameIndex].style
                                            "
                                        >
                                            <td>
                                                {{ propName }}
                                            </td>
                                            <td
                                                v-for="(prop,
                                                propIndex) in prop.props.filter(
                                                    value =>
                                                        value.name == propName
                                                )"
                                                :key="propIndex"
                                                class="center"
                                            >
                                                {{ prop.value }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                v-else-if="
                                    prop.title ===
                                        extraProductTitles.BRANCH_OVERVIEW
                                            .name ||
                                        prop.title ===
                                            extraProductTitles.RESTOCKING.name
                                "
                            >
                                <v-row
                                    no-gutters
                                    v-for="(prop, propIndex) in prop.props"
                                    :key="`prop${propIndex}`"
                                    :style="prop.style"
                                >
                                    <v-col cols="auto" class="mr-auto py-1">
                                        {{ prop.name }}:
                                    </v-col>
                                    <v-col class="py-1 pl-2">
                                        <span class="item-value">{{
                                            prop.value
                                        }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>
                        <template slot="prop" slot-scope="{ prop }">
                            <v-text-field
                                v-if="
                                    prop.name ===
                                        extraProductTitles.SOLICITATION
                                            .subTitles.REQUESTED_QUANTITY
                                "
                                class="card-text-field"
                                v-model="i[prop.key]"
                                :placeholder="prop.value"
                                :label="prop.value"
                                type="number"
                                min="1"
                                hide-details="auto"
                                :disabled="disableRequestedQuantityInput"
                                @change="changeQuantity(index, true)"
                            />
                            <v-text-field
                                v-else-if="
                                    prop.name ===
                                        extraProductTitles.SOLICITATION
                                            .subTitles.APPROVED_QUANTITY
                                "
                                class="card-text-field"
                                v-model="i[prop.key]"
                                :placeholder="prop.value"
                                type="number"
                                min="1"
                                hide-details="auto"
                                :disabled="disableApprovedQuantityInput"
                                @change="changeQuantity(index)"
                            />
                            <v-select
                                v-else-if="
                                    prop.name ===
                                        extraProductTitles.SOLICITATION
                                            .subTitles.REASON
                                "
                                v-model="i[prop.key]"
                                :items="reasons"
                                item-text="description"
                                item-value="id"
                                cache-items
                                class="card-select-field"
                                flat
                                hide-no-data
                                hide-details="auto"
                            />
                            <v-textarea
                                v-else-if="
                                    prop.name ===
                                        extraProductTitles.SOLICITATION
                                            .subTitles.NOTE
                                "
                                v-model="i[prop.key]"
                                class="card-textarea-field"
                                no-resize
                                rows="2"
                                hide-details="auto"
                                :value="i[prop.key]"
                                :disabled="disableNoteInput"
                            />
                        </template>
                    </flip-card>
                </div>
            </div>
        </div>
        <div id="save-btn">
            <Button
                v-show="items.length > 0"
                @click.native="openSaveModal"
                label="Salvar Pedido"
                color="#3F51B5"
            />
        </div>
        <modal v-show="openModal" text-align="center">
            <template slot="header">
                <h1>Confirmar a criação do pedido</h1>
            </template>
            <template slot="body">
                <div v-show="creating" class="text-center">
                    <img src="loader.svg" style="width: 100px; height: 100px" />
                </div>
                <div v-show="!creating">
                    <p>
                        <span>Filial: </span
                        >{{ branch && branch.name ? branch.name : '' }}
                    </p>
                    <p><span>Tipo de pedido: </span>Produto Extra</p>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Produtos
                                </th>
                                <th>
                                    Quantidade
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="index">
                                <td>
                                    {{
                                        item.title.length <= 40
                                            ? item.title
                                            : item.title.substring(0, 40) +
                                              '...'
                                    }}
                                </td>
                                <td>
                                    {{
                                        item.approvedQuantity
                                            ? item.approvedQuantity
                                            : item.requestedQuantity
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template slot="footer">
                <div class="confirm-btns">
                    <Button
                        class="left"
                        @click.native="openModal = false"
                        label="Não"
                        color="#f55a4e"
                        :disabled="creating"
                    />
                    <Button
                        class="right"
                        @click.native="create"
                        label="Sim"
                        color="#3F51B5"
                        :disabled="creating"
                    />
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { FlipCard } from '@/components'
import MaximizeAndMinimize from '@/components/Maximize/MaximizeAndMinimize.vue'
import Button from '@/components/Button/Button.vue'
import { Modal } from '@/components'
import { Solicitation as Model } from '@/models/solicitation.model'
import { parameterActions as Actions } from '@/services/constants/index.js'
import {
    solicitationTypes as Types,
    status as Status
} from '@/services/constants/index.js'

const CARD_COLORS = {
    NET_VALUE_LTE_ZERO: '#ffbfaa',
    NET_VALUE_GT_ZERO_AND_NET_STOCK_LTE_ZERO: '#ece75f',
    DEFAULT: '#fff'
}

export default {
    name: 'extra-product-page',
    props: {
        items: {
            type: Array,
            required: true
        },
        itemsBackups: {
            type: Array,
            required: false
        },
        _create: {
            type: Function,
            required: true
        }
    },
    async created() {
        this.isPublic = this.$route.meta.public ?? false
        this.cardModel = Model.extraProductCard()
        await this.readSolicitationReasons()
    },
    data() {
        return {
            creating: false,
            isPublic: false,
            openModal: false,
            searchProducts: null,
            product: null,
            productList: [],
            searchBranches: null,
            cardModel: {},
            isCreate: true,
            loading: false,
            branchStockState: {},
            dCStockState: {},
            disableBranchSearch: false,
            extraProductTitles: Model.cardTitles().EXTRA_PRODUCT,
            typeRequestExtraProduct: Types.TYPE_REQUEST_EXTRA_PRODUCT_PK
        }
    },
    computed: {
        ...mapState({
            me: state => state['auth'].me,
            stockState: state => state['movements'].stockState[0],
            solicitationReasons: state => state['solicitations'].reasons,
            branchParameter: state => state['branchparameter'].page.results[0],
            productInfo: state => state['branchparameter'].listProduct[0],
            branches: state => state['branches'].page.results,
            branch: state => state['branches'].branch,
            products: state => state['products'].page.results
        }),

        reasons() {
            return this.solicitationReasons.filter(reason => reason.id !== '')
        },

        disableApprovedQuantityInput() {
            return !(
                this.me.permissions.includes(
                    'solicitations.can_add_approved_quantity'
                ) &&
                this.me.permissions.includes(
                    'solicitations.can_change_approved_quantity'
                )
            )
        },

        disableRequestedQuantityInput() {
            return !(
                this.disableApprovedQuantityInput &&
                this.me.permissions.includes(
                    'solicitations.can_add_requested_quantity'
                ) &&
                this.me.permissions.includes(
                    'solicitations.can_change_requested_quantity'
                )
            )
        },

        disableNoteInput() {
            return !(
                this.me.permissions.includes('solicitations.can_add_note') &&
                this.me.permissions.includes('solicitations.can_change_note')
            )
        },
        branch: {
            get() {
                return this.$store.state['branches'].branch
            },
            set(value) {
                this.readBranchSuccess(value)
            }
        }
    },
    methods: {
        ...mapActions('movements', {
            readStockState: 'read'
        }),

        ...mapActions('branches', {
            readBranches: 'read'
        }),

        ...mapActions('branchparameter', {
            readBranchParameters: 'read',
            readDetailProduct: 'readDetailProduct'
        }),

        ...mapActions('products', {
            readProducts: 'read'
        }),

        ...mapActions('solicitations', {
            readSolicitationReasons: 'readReasons'
        }),

        ...mapMutations('branches', {
            readBranchSuccess: 'readBranchSuccess',
            mapBranchesNames: 'mapNames'
        }),

        ...mapMutations('products', {
            mapProductsNames: 'mapNames'
        }),

        async setStockState(products, quantity = 0) {
            const stack_items = this.branchParameter?.stack_items ?? 0
            const showcase_items = this.branchParameter?.showcase_items ?? 0
            const coverage = this.branchParameter?.coverage ?? 0

            await this.readStockState({
                products,
                branch: this.branch.id,
                quantity,
                coverage,
                stack_items,
                showcase_items
            })
            const { parent_stock_state, ...rest } = this.stockState
            this.branchStockState = rest
            this.dCStockState = parent_stock_state
        },

        async loadProductData() {
            const products = [this.product.id]
            await this.readBranchParameters({
                products,
                branch_id: this.branch.id
            })
            await this.setStockState(products)
            await this.readDetailProduct({ products, branch: this.branch.id })
        },

        setCardPropStyle(item, prop) {
            let style = {}
            if (
                (item.title == this.extraProductTitles.BRANCH_OVERVIEW.name &&
                    prop.name ==
                        this.extraProductTitles.BRANCH_OVERVIEW.subTitles
                            .RESERVED_STOCK) ||
                prop.name ==
                    this.extraProductTitles.DC_OVERVIEW.subTitles.NET_STOCK ||
                prop.name ==
                    this.extraProductTitles.RESTOCKING.subTitles
                        .CONSIDERED_STOCK ||
                prop.name ==
                    this.extraProductTitles.RESTOCKING.subTitles.HAS_RESTOCKING
            ) {
                style = {
                    fontWeight: 'bold',
                    color: 'rgb(63, 81, 181)'
                }
            }

            return style
        },

        setCardPropValue(item, prop) {
            switch (item.title) {
                case this.extraProductTitles.BRANCH_OVERVIEW.name:
                    return this.branchStockState
                        ? this.branchStockState[prop.key]
                        : ''
                case this.extraProductTitles.DC_OVERVIEW.name:
                    return this.dCStockState ? this.dCStockState[prop.key] : ''
                case this.extraProductTitles.RESTOCKING.name:
                    let value = ''
                    if (prop.key !== 'considered_stock') {
                        if (this.branchParameter) {
                            value =
                                prop.key == 'has_restocking'
                                    ? this.branchParameter.actions.includes(
                                          Actions.ACTION_RESTOCKING_PK
                                      )
                                        ? 'Ligada'
                                        : 'Desligada'
                                    : this.branchParameter[prop.key]
                        }
                    } else if (this.branchStockState) {
                        value = this.branchStockState[prop.key] ?? ''
                    }
                    return value
            }
        },

        mapCardValues() {
            this.cardModel = {
                ...this.cardModel,
                branch: this.branch,
                product: this.product.id,
                referenceNumber: this.product.reference_number,
                title: this.product.name,
                img: this.product.image_url,
                requestedQuantity: null,
                approvedQuantity: null,
                curve: this.productInfo?.curve ?? '',
                ads: this.stockState?.ads,
                dCNetSolicitation: this.dCStockState?.net_solicitation,
                dCNetValue: this.dCStockState?.net_value,
                backgroundColor: this.getCardColor(),
                isNew: this.branchParameter?.is_new ?? '',
                isGuaranteedStock: this.branchParameter?.guaranteed_stock ?? '',
                isFavorite: this.branchParameter?.is_favorite ?? '',
                data: this.cardModel.data.map(item => {
                    return {
                        ...item,
                        props: item.props.map(prop => {
                            return {
                                ...prop,
                                style: this.setCardPropStyle(item, prop),
                                value: this.setCardPropValue(item, prop)
                            }
                        })
                    }
                })
            }
        },

        notifyMessage(message, type = 'danger') {
            this.$emit('notify', { message, type })
        },

        async addProduct() {
            const productExists = this.items.some(
                item =>
                    item.product === this.product.id &&
                    item.branch.external_id === this.branch.external_id
            )
            if (this.branch && !productExists) {
                this.loading = true

                try {
                    await this.loadProductData()
                    this.mapCardValues()
                    this.items.push(this.cardModel)
                    this.itemsBackups.push(this.cardModel)
                    this.product = null
                } catch (e) {
                    this.notifyMessage(
                        'Desculpe, houve um erro ao adicionar esse item. Tente novamente mais tarde.'
                    )
                }

                this.loading = false
            } else if (productExists) {
                this.notifyMessage(
                    'O produto já foi adicionado para esta filial'
                )
            } else {
                const message = this.isPublic
                    ? 'É necessário selecionar um produto'
                    : 'É necessário selecionar uma filial e um produto'
                this.notifyMessage(message)
            }
        },

        removeProduct(index) {
            this.items.splice(index, 1)
            this.itemsBackups.splice(index, 1)
        },

        filterProducts() {
            clearTimeout(this._timerId)

            this._timerId = setTimeout(async () => {
                await this.readProducts({
                    q: this.searchProducts
                })
                this.mapProductsNames()
            }, 500)
        },

        filterBranches() {
            clearTimeout(this._timerId)

            this._timerId = setTimeout(async () => {
                await this.readBranches({
                    q: this.searchBranches
                })
                this.mapBranchesNames()
            }, 500)
        },

        openSaveModal() {
            const quantityKey = this.disableRequestedQuantityInput
                ? 'approvedQuantity'
                : 'requestedQuantity'

            const hasNotQuantity = this.items.some(
                item => isNaN(item[quantityKey]) || item[quantityKey] <= 0
            )
            if (hasNotQuantity) {
                this.notifyMessage(
                    'É necessário adicionar uma quantidade maior que zero'
                )
            } else {
                this.openModal = true
            }
        },

        async create() {
            this.creating = true
            const quantityKey = this.disableRequestedQuantityInput
                ? 'approvedQuantity'
                : 'requestedQuantity'

            const solicitation = {
                branch: this.branch.id,
                items: this.items.map(item => {
                    return {
                        branch: item.branch.id,
                        product: item.product,
                        reason: item.reason ?? null,
                        quantity: parseInt(item[quantityKey]),
                        solicitation_type: this.typeRequestExtraProduct,
                        note: item.note
                    }
                })
            }
            await this._create(solicitation)
            this.openModal = false
            this.creating = false
        },

        getIndexesAndKey(index, title, key, isBranch = true) {
            const dataIndex = this.items[index].data.findIndex(
                d => d.title == title
            )
            const props = this.items[index].data[dataIndex].props

            return {
                dataIndex,
                propIndex: props.findIndex(item => item.key == key),
                key,
                stockState: isBranch ? this.branchStockState : this.dCStockState
            }
        },

        getCardColor(quantity = 0) {
            return (quantity > 0 && this.dCStockState?.net_value < 0) ||
                (quantity == 0 && this.dCStockState?.net_value <= 0)
                ? CARD_COLORS.NET_VALUE_LTE_ZERO
                : this.dCStockState?.net_value > 0 &&
                  this.dCStockState?.net_stock <= 0
                ? CARD_COLORS.NET_VALUE_GT_ZERO_AND_NET_STOCK_LTE_ZERO
                : CARD_COLORS.DEFAULT
        },

        changeCardColor(index, quantity) {
            this.items[index].backgroundColor = this.getCardColor(quantity)
        },

        async changeQuantity(index, isRequestedQuantity = false) {
            const item = this.items[index]
            const field = isRequestedQuantity
                ? 'requestedQuantity'
                : 'approvedQuantity'
            let quantity = parseInt(item[field])
            quantity = !quantity || isNaN(quantity) ? 0 : quantity
            await this.setStockState([item.product], quantity)
            const branchOverview = this.extraProductTitles.BRANCH_OVERVIEW.name
            const dCOverview = this.extraProductTitles.DC_OVERVIEW.name
            const indexes = [
                this.getIndexesAndKey(index, branchOverview, 'total_stock'),
                this.getIndexesAndKey(index, dCOverview, 'net_stock', false),
                this.getIndexesAndKey(index, dCOverview, 'total_stock', false)
            ]

            indexes.forEach(i => {
                const choosedKey =
                    i.key == 'approvedCoverage'
                        ? 'coverage'
                        : i.key == 'approvedStock'
                        ? 'net_stock'
                        : i.key
                this.items[index].data[i.dataIndex].props.splice(
                    i.propIndex,
                    1,
                    {
                        ...item.data[i.dataIndex].props[i.propIndex],
                        value: i.stockState ? i.stockState[choosedKey] : ''
                    }
                )
            })

            this.items.splice(index, 1, {
                ...this.itemsBackups[index],
                requestedQuantity: item.requestedQuantity ?? null,
                approvedQuantity: item.approvedQuantity ?? null
            })

            this.changeCardColor(index, quantity)
        }
    },
    watch: {
        searchProducts: {
            handler: function(val) {
                val && val !== this.product && this.filterProducts()
            }
        },
        searchBranches: {
            handler: function(val) {
                val && val !== this.branch && this.filterBranches()
            }
        },
        items: {
            handler: function(val) {
                this.disableBranchSearch = val.length > 0
            }
        }
    },
    components: {
        MaximizeAndMinimize,
        FlipCard,
        Button,
        Modal
    }
}
</script>

<style scoped>
.add-btn {
    margin: 15px 0px;
}
.card-content {
    padding: 20px;
}
.card-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
}
.card-row::after {
    content: '';
    flex: auto;
}
.card-column {
    max-width: 400px;
    height: 730px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 400px;
    margin-bottom: 100px;
}
.card-text-field,
.card-select-field,
.card-textarea-field {
    margin-top: -25px;
    margin-left: 10px;
    margin-bottom: 10px;
}
.card-text-field {
    width: 100px;
}
.card-select-field,
.card-textarea-field {
    max-width: 220px;
}
.v-card,
li {
    margin-bottom: 30px;
}
ul {
    list-style: none;
}
#save-btn {
    position: fixed;
    bottom: 0;
    padding: 5px 15px;
}
.modal-header > h1 {
    font-size: 18px;
}
.modal-header > h1,
.modal-body > p > span {
    font-weight: bold;
}
.confirm-btns {
    display: inline-block;
    width: 100%;
}
.confirm-btns > .btn {
    width: 49%;
}
.left {
    float: left;
}
.right {
    float: right;
}
.card-table {
    width: 100%;
}
.card-table .center {
    text-align: center;
}
.card-table td {
    padding: 4px 0px;
}
@media (min-width: 601px) {
    .add-btn {
        float: right;
    }
    #save-btn {
        right: 2%;
    }
}
@media (max-width: 600px) {
    .v-card {
        text-align: center;
    }
    #save-btn {
        width: 100%;
        left: 0;
    }
    .add-btn > .btn,
    #save-btn > .btn {
        width: 100%;
    }
}
</style>
